import {
  SUBMIT_COMPETITOR_PROFILE_REQUEST,
  SUBMIT_COMPETITOR_PROFILE_SUCCESS,
  SUBMIT_COMPETITOR_PROFILE_FAILURE,
} from "../actions/competitorProfileActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const competitorProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_COMPETITOR_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default competitorProfileReducer;
